/* eslint-disable max-len */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'bootstrap';
import { FaCheck, FaRegClock } from 'react-icons/fa';
import useTranslation from '../../hooks/useTranslation';
import { hideModal, showModal } from '../../redux/actions/sessionTimeOutModalAction';
import { signinSilent } from '../../services/authService';
import { IDENTITY_ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME } from '../../constants/authConstants';
import store from '../../redux/store';
import EpButton from '../EpButton';
import EpModal from '../EpModal';
import './styles.scss';

export const handleShowSessionTimeOutModal = (modalIntance, modalNewVisibility) => {
  const sessionTimeOutModalIntance = new Modal(document.getElementById('modal--session-timeout'), { backdrop: 'static' });
  store.dispatch(showModal('SESSION_TIMEOUT', sessionTimeOutModalIntance));

  if (modalNewVisibility && modalIntance == null) {
    sessionTimeOutModalIntance.show();
  }
};

export default function EpSessionTimeOutModal() {
  // Tags do Globalization
  const YourSessionWillCloseIn = useTranslation('Your session will close in');
  const Seconds = useTranslation('Seconds');
  const StayConnected = useTranslation('Stay connected');

  const dispatch = useDispatch();
  const sessionTimeOutModalInstance = useSelector(state => state.modal.instance);
  const sessionTimeOutModalVisibility = useSelector(state => state.modal.isOpened);

  // eslint-disable-next-line max-len
  const [timeLeftUserSession, setTimeLeftUserSession] = useState(IDENTITY_ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME);

  setTimeout(() => {
    if (sessionTimeOutModalVisibility && timeLeftUserSession > 0) {
      const currentTimeLeft = timeLeftUserSession - 1;
      setTimeLeftUserSession(currentTimeLeft);
    } else if (!sessionTimeOutModalVisibility) {
      setTimeLeftUserSession(IDENTITY_ACCESS_TOKEN_EXPIRING_NOTIFICATION_TIME);
    }

    return timeLeftUserSession;
  }, 1000);

  const handleRenewUserSession = () => {
    sessionTimeOutModalInstance.hide();
    signinSilent();
    dispatch(hideModal());
  };

  const bodyContent = (
    <>
      <div className="modal__content-body-icon-wrapper" id="modal__content-body-icon-wrapper--session-timeout">
        <FaRegClock className="modal__content-body-icon" id="modal__content-body-icon--session-timeout" />
      </div>
      <span className="modal__content-body-title" id="modal__content-body-title--session-timeout">{YourSessionWillCloseIn}</span>
      <span className="modal__content-body-value" id="modal__content-body-value--session-timeout">{timeLeftUserSession}</span>
      <span className="modal__content-body-description" id="modal__content-body-description--session-timeout">{Seconds}</span>
    </>
  );

  const footerContent = (
    <EpButton actionType="button" labelText={StayConnected} linkFunc={() => handleRenewUserSession()} buttonType="primary-outline" buttonIcon={<FaCheck className="btn__icon" />} customClass="btn__footer" disabled={false} />
  );

  return (
    <EpModal
      modalId="modal--session-timeout"
      modalType="SESSION_TIMEOUT"
      bodyContent={bodyContent}
      footerContent={footerContent}
      alignFooter="justify-content-center"
      size="sm"
      noHeader
    />
  );
}
